import { render, staticRenderFns } from "./teams-form.vue?vue&type=template&id=1f50882c&scoped=true&lang=pug&"
import script from "./teams-form.vue?vue&type=script&lang=ts&"
export * from "./teams-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50882c",
  null
  
)

export default component.exports